import AppPresenter from '../App';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import {requestUserLogout} from "../actions/loggedUser";
import {isAdminUser, isSetupUser} from "../utils/AuthHelper";




const mapStateToProps = (state) => ({
    token: (state.loggedUser && state.loggedUser.token) ?  state.loggedUser.token : null,
    loggedUser: (state.loggedUser && state.loggedUser.user) ?  state.loggedUser.user : null,
    isAdmin: isAdminUser(state),
    hasSetupRight: isSetupUser(state),
});

const mapDispatchToProps = dispatch => {
    return {
        onLogout: (keycloak) => {
            dispatch(requestUserLogout());
            keycloak.logout();
        },
    }
};


const App = connect(mapStateToProps, mapDispatchToProps)(AppPresenter);

export default App;

// App.propTypes = {
//     keycloak: PropTypes.any.isRequired
// };